import { TranslateService } from '@ngx-translate/core';

import { CodeTypeModel } from '../core/models/code-type';
import { RadioModel }    from '../shared/controls/radio-group/typings/radio';

import {
  WORKSHOP_TYPE_DEFAULT_ICON,
  WORKSHOP_TYPE_ICONS
}                          from './company.workshop-types.constants';

// The tile options for the workshop types from CompanyService.getCompanyTypes.
export function toWorkshopTypeOptions ( types : Array<CodeTypeModel>, translateService : TranslateService ) : Array<RadioModel> {
  return types.map(( type : CodeTypeModel ) => ({
    ...(WORKSHOP_TYPE_ICONS[type.code] || WORKSHOP_TYPE_DEFAULT_ICON),
    label: translateService.instant(type.language_label),
    name : type.code,
    value: type.code
  }));
}
